import { render } from "./InsertSharedAccordionDetail.vue?vue&type=template&id=068f1860&scoped=true"
import script from "./InsertSharedAccordionDetail.vue?vue&type=script&lang=js"
export * from "./InsertSharedAccordionDetail.vue?vue&type=script&lang=js"

import "./InsertSharedAccordionDetail.vue?vue&type=style&index=0&id=068f1860&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068f1860"],['__file',"src/components/sharedAccordionDetail/InsertSharedAccordionDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "068f1860"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('068f1860', __exports__)) {
    api.reload('068f1860', __exports__)
  }
  
  module.hot.accept("./InsertSharedAccordionDetail.vue?vue&type=template&id=068f1860&scoped=true", () => {
    api.rerender('068f1860', render)
  })

}


export default __exports__